module.exports = __webpack_public_path__ + "static/media/L diag.8d2df571.kra";